import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

// Un proyecto Firebase por ambiente (carnavalapp-dev / prod), inyectado por
// build igual que antes REACT_APP_AUTH0_* — ver los workflows de
// Azure Static Web Apps (dev y prod) y .env.local para desarrollo local.
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

const firebaseApp = initializeApp(firebaseConfig);

export const auth = getAuth(firebaseApp);
